<template>
  <div id="users-slim-list">
    <vs-table
      ref="transferTicketTable"
      noDataText="Nenhum usuário online"
      pagination
      :max-items="itemsPerPage"
      :data="users"
    >
      <template slot="thead">
        <vs-th v-if="checkbox"></vs-th>
        <vs-th></vs-th>
        <vs-th>Nome</vs-th>
        <vs-th>Email</vs-th>
        <vs-th>Departamento</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <vs-checkbox v-model="selecteds" :vs-value="tr.id">
              </vs-checkbox>
            </vs-td>

            <vs-td>
              <vs-avatar :src="tr.image"></vs-avatar>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">
                {{ tr.name }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.email }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-name font-medium">
                {{ tr.userDepartment ? tr.userDepartment.name : '' }}
              </p>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  props: {
    checkbox: {
      type: Boolean,
      required: false
    },
    selecteds: {
      required: false,
      default(){ return [] },
      validator: prop => typeof prop === 'object' || prop === null
    }
  },
  data() {
    return {
      itemsPerPage: 4
    }
  },
  computed: {
    users() {
      return this.$store.state.user.users
    },
  },
  created() {
    this.$store.dispatch("user/fetch")
  },
  watch: {
    selecteds: function() {
      this.$emit("selectedUsers", this.selecteds);
    }
  }
}
</script>
